import React from 'react';
import WorkHistoryIcon from '@mui/icons-material/WorkHistory';
import Button from '@mui/material/Button';
import { always, compose } from 'ramda';
import { useHistory } from 'react-router-dom';
import { ChecklistCard } from 're-enrollment-checklist/ChecklistCard';
import { ReEnrollmentChecklistPlan } from 're-enrollment-checklist/re-enrollment-checklist.types';
import setLegacyChecklistCompletionProgress from 'shared/utils/set-legacy-checklist-completion-progress';

function DirectBillPlanCard({ plan }: { plan: ReEnrollmentChecklistPlan; }) {
  const history = useHistory();

  const icon = <WorkHistoryIcon style={ { fontSize: 32 } } />;
  const buttons = (
    <div className="justify-start">
      <Button
        variant="outlined"
        className="mr-5"
        data-testid="db-link"
        onClick={compose(
          history.push,
          always(`/reenrollment-checklist/db/${plan.planYearId}`),
        )}
      >
        <div className="justify-start">
          <div>Direct Bill Account</div>
        </div>
      </Button>
    </div>
  );

  return (
    <ChecklistCard
      icon={icon}
      title="Direct Billing Re-Enrollment Checklist"
      planYearStart={plan.planYearStart}
      planYearEnd={plan.planYearEnd}
      buttons={buttons}
      progress={setLegacyChecklistCompletionProgress(plan.legacyChecklistComplete)}
    />
  );
}

export default DirectBillPlanCard;
